// extracted by css-extract-rspack-plugin
export default {"section":"PersonalType__section--mklww"};